// extracted by mini-css-extract-plugin
module.exports = {"DesktopGutters":"index-module--DesktopGutters--KG8l6","FooterDesktop":"index-module--FooterDesktop--106gy"};